import { FC, useState } from 'react';
import './forgot.css';
import { ForgotPasswordProps } from './forgot.type';
import { useTranslation } from 'react-i18next';
import { LoginPlaceholder } from '../../utils/helper.type';
import { useResponsiveLayout } from '../../hooks/useResponsiveLayout';
import { route } from '../../service/router';
import { useNavigate } from 'react-router-dom';
import { renderDesktopView, renderTabletView } from './forgotHelper';
import { useForgotPasswordData } from '../../hooks/useAuthData';

const ForgotPassword: FC<ForgotPasswordProps> = () => {
  const { isDesktop } = useResponsiveLayout();
  const [email, setEmail] = useState<string>('');

  const { forgotPassword, isForgotLoading } = useForgotPasswordData();

  const handleSendLink = async (e: React.FormEvent) => {
    if (isForgotLoading) {
      console.log(
        '[ForgotPassword] Already in progress... skipping this request',
      );
      return;
    }
    e.preventDefault();
    await forgotPassword(email);
  };

  const { i18n } = useTranslation();
  const loginTranslation: LoginPlaceholder =
    i18n.getResourceBundle(i18n.language, 'translation')?.login.placeholder ||
    {};
  const navigate = useNavigate();

  const isDisabled = email.trim() === '';

  const onClickLogin = () => {
    navigate(route.login);
  };

  const handleBackToLogin = (): void => {
    navigate(route.login);
  };

  return (
    <div className="relative min-h-screen w-full">
      {/* Desktop layout, hidden at medium or smaller screen size */}
      {isDesktop
        ? renderDesktopView(
            handleSendLink,
            email,
            setEmail,
            loginTranslation,
            isDisabled,
            onClickLogin,
            isForgotLoading,
          )
        : renderTabletView(
            handleBackToLogin,
            email,
            setEmail,
            handleSendLink,
            loginTranslation,
            'forgotPassword.forgotText',
            isDisabled,
            isForgotLoading,
          )}
    </div>
  );
};
export default ForgotPassword;
